<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div data-id="mPower-Supplier-List" data-cy="suppliers-list-page">
    <div class="d-flex justify-content-between align-center mb-3">
      <h1 class="m-0">Suppliers</h1>
      <b-button-group v-if="canCreateSupplier">
        <router-link :to="'/suppliers/create'" class="btn btn-light info-suppliers-create">
          Create Supplier
        </router-link>
        <b-dropdown right variant="light" class="intro-customer-import">
          <b-dropdown-item @click="showImportSupplier" data-cy="suppliers-import-csv">Import CSV</b-dropdown-item>
        </b-dropdown>
      </b-button-group>
    </div>
    <top-table
      :tabFilters="options.tabFilters"
      :columns="[
        'name',
        'status',
        'isEQP',
        'hasCred',
        //'asiNumber',
        //'psCode',
        'accountNumber',
        'isDecorator',
        'localizationCountry',
        // 'readyToGrab',
        // 'endpoints',
        'productsSellableCount',
        'hasActiveProducts',
        'dataQualityScore'
        // 'percent',
        // 'productsWithErrors'
        //'isActive'
      ]"
      :headings="options.headings"
      :sortable="[
        'name',
        'status',
        // 'asiNumber',
        'isEQP',
        'isActive',
        'hasCred',
        //'psCode',
        'accountNumber',
        'localizationCountry',
        'readyToGrab',
        'isDecorator',
        'productsSellableCount',
        'hasActiveProducts',
        'dataQualityScore',
        'percent'
      ]"
      :order-by="{ column: 'name', ascending: 1 }"
      url="/suppliers"
      :request-function="onBeforeReq"
      :overlap="true"
      :hasClearFilters="true"
      :searchColumns="['localizationCountry']"
    >
      <template v-slot:hasCred="props">
        <img
          src="/img/PromoStandards-Icon.png"
          width="24"
          height="24"
          class="ml-2"
          v-if="props.row.hasCred"
          v-b-tooltip.hover
          title="PromoStandards order and shipping status active"
      /></template>
      <template v-slot:productsSellableCount="props">
        <div class="d-flex" v-if="props.row.stats?.length">
          <div v-for="locale in props.row.stats" class="d-flex mr-2">
            <ImgLocale :locale="locale.locale" class="mr-2" />
            <span>{{ locale.total_sellable }}</span>
          </div>
        </div>
        <span v-else>{{ props.row.productsSellableCount }}</span>
      </template>
      <template v-slot:hasActiveProducts="props">
        <div class="d-flex" v-if="props.row.stats?.length">
          <div v-for="locale in props.row.stats" class="d-flex mr-2">
            <ImgLocale :locale="locale.locale" class="mr-2" />
            <span>{{ locale.total_active }}</span>
          </div>
        </div>
        <span v-else>{{ props.row.hasActiveProducts }}</span>
      </template>
      <template v-slot:dataQualityScore="props">
        <router-link :to="`/suppliers/${props.row._id}?tab=Data Quality`" :data-cy="`suppliers-row-data-quality-${props.row._id}`">
          <div class="d-flex align-items-center">
            <DataQualityScore v-if="props.row.dataQualityScore" :score="props.row.dataQualityScore" size="sm" />
            <img
              src="/img/PromoStandards-Icon.png"
              width="24"
              height="24"
              class="ml-2"
              v-if="props.row.readyToGrab"
              v-b-tooltip.hover
              title="PromoStandards"
            />
          </div>
        </router-link>
      </template>
      <template v-slot:percent="props">
        <div class="d-flex" v-if="props.row.stats?.length">
          <div v-for="locale in props.row.stats" class="d-flex mr-2">
            <ImgLocale :locale="locale.locale" class="mr-2" />
            <span>{{ (locale.total_active / locale.total_sellable) | percent }}</span>
          </div>
        </div>
      </template>
      <template v-slot:name="props">
        <router-link :to="`/suppliers/${props.row._id}`" :data-cy="`suppliers-row-${props.row._id}`">
          {{ props.row.name }}
        </router-link>
        <div class="small text-muted">{{ props.row.psCode }}</div>
      </template>
      <template v-slot:status="props">
        <SupplierStatus :status="SUPPLIER_STATUS.find((e) => e.val === props.row.status)" />
      </template>
      <template v-slot:endpoints="props">
        <div class="d-flex flex-wrap">
          <div
            v-for="e in props.row.endpoints"
            class="badge badge-secondary mr-1 mb-1"
            v-b-tooltip.hover
            :title="`${e.serviceName}-${e.version}-${e.liveURL}`"
          >
            {{ e.code }}
          </div>
        </div>
      </template>
      <template v-slot:isEQP="props">
        {{ formatBoolean(props.row.isEQP) }}
      </template>

      <template v-slot:localizationCountry="props">
        <CountryFlags :countries="props.row.localizationCountry" />
      </template>
      <template v-slot:isActive="props">
        {{ formatBoolean(props.row.isActive) }}
      </template>

      <template v-slot:isDecorator="props">
        {{ formatBoolean(props.row.isDecorator) }}
      </template>

      <template v-slot:readyToGrab="props">
        <span v-if="!props.row.readyToGrab"> No </span>
        <span v-else-if="props.row.error" class="text-danger"> Error with Sellable Request </span>
        <span v-else> Yes </span>
      </template>
      <template v-slot:productsWithErrors="props">
        <template>
          <button type="button" class="btn btn-warning" data-toggle="dropdown">
            <i class="far fa-exclamation-triangle fa-1x"></i>
          </button>
          <div class="dropdown-menu">
            <div class="h5 dropdown-item">Product Data Issues</div>
            <div
              v-for="(err, index) in props.row.productsWithErrors"
              :key="index"
              class="dropdown-item d-flex justify-content-between"
            >
              <div>
                {{ err._id }}
                <i class="fas fa-question-circle text-light" :id="`error-${props.row.psCode}-${index}`"></i>
                <b-popover :target="`error-${props.row.psCode}-${index}`" triggers="hover" placement="bottom">
                  {{ errorMessage(err._id) }}
                </b-popover>
              </div>
              <strong>{{ err.count }}</strong>
            </div>
          </div>
        </template>
      </template>
    </top-table>
    <b-modal
      ref="supplierImport"
      title="Import Suppliers"
      scrollable
      hide-footer
      modal-class="modal right fade"
      dialog-class="modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-lg"
      content-class="no-max-height"
      data-cy="suppliers-import-modal"
    >
      <SupplierImportCSV @submit="submitSupplierImport" @cancel="hideImportSupplier" />
    </b-modal>
  </div>
</template>
<script>
import pageWalkthroughHelperMixin from '@/mixins/pageWalkthroughHelperMixin';
import { SUPPLIER_STATUS } from '../../utils';
import { serviceName } from '../../../constants';
import { ROLES_ACCESS } from '../../utils';
import { getFlagEmoji, getCountryName } from '@/utils/countryUtils';
export default {
  name: 'SuppliersList',
  mixins: [pageWalkthroughHelperMixin],
  components: {
    ImgLocale: () => import('@/components/ImgLocale'),
    SupplierStatus: () => import('../../Administration/Suppliers/SupplierStatus'),
    SupplierImportCSV: () => import('./components/SupplierImportCSV'),
    Flag: () => import('@mtntop/utils/src/components/PhoneField/Flag'),
    CountryFlags: () => import('@/components/CountryFlags'),
    DataQualityScore: () => import('@/components/Suppliers/DataQualityScore')
  },
  data() {
    return {
      SUPPLIER_STATUS,
      options: {
        tabFilters: [
          {
            val: 'isEQP',
            name: 'EQP',
            criteria: [
              {
                val: true,
                label: 'Yes'
              },
              {
                val: false,
                label: 'No'
              }
            ]
          },
          {
            val: 'isActive',
            name: 'Active',
            criteria: [
              {
                val: true,
                label: 'Yes'
              },
              {
                val: false,
                label: 'No'
              }
            ]
          },
          {
            val: 'hasCred',
            name: 'PS Credentials',
            criteria: [
              {
                val: true,
                label: 'Yes'
              },
              {
                val: false,
                label: 'No'
              }
            ]
          },
          {
            val: 'canGrab',
            name: 'PS Active(can grab)',
            criteria: [
              {
                val: true,
                label: 'Yes'
              },
              {
                val: false,
                label: 'No'
              }
            ]
          },
          {
            val: 'hasEndpoints',
            name: 'Has endpoints',
            criteria: serviceName().map((label) => ({ label, val: label }))
          },
          {
            val: 'noEndpoints',
            name: 'No endpoints',
            criteria: serviceName().map((label) => ({ label, val: label }))
          },
          {
            val: 'isDecorator',
            name: 'Is Decorator',
            criteria: [
              {
                val: true,
                label: 'Yes'
              },
              {
                val: false,
                label: 'No'
              }
            ]
          },
          {
            val: 'status',
            name: 'PS status',
            criteria: SUPPLIER_STATUS.map((e) => ({ ...e }))
          },
          {
            val: 'localizationCountry',
            name: 'Country',
            label: 'Country',
            pathToLoadCriteria: '/suppliers/countries',
            mapCriteria: (country) => ({
              val: country.code,
              label: `${getFlagEmoji(country.code)} ${getCountryName(country.code)} (${country.count})`
            })
          }
        ],

        headings: {
          name: 'Name',
          isEQP: 'EQP',
          isActive: 'Active',
          hasCred: 'PS Credentials',
          psCode: 'Code',
          asiNumber: 'ASI',
          sageNumber: 'Sage',
          accountNumber: 'Account ID',
          localizationCountry: 'Country',
          readyToGrab: 'PS Active',
          isDecorator: 'Is Decorator',
          productsSellableCount: 'PS Sellable',
          // productsWithErrors: 'PS Errors',
          hasActiveProducts: 'Active Products',
          dataQualityScore: 'Data Quality',
          percent: 'PS Percent'
        }
      }
    };
  },
  methods: {
    formatBoolean(value) {
      return value ? 'Yes' : 'No';
    },
    showImportSupplier() {
      this.$refs.supplierImport.show();
    },
    submitSupplierImport() {
      this.notificateSuccess('Successfully imported');
    },
    hideImportSupplier() {
      this.$refs.supplierImport.hide();
    },
    onBeforeReq(p) {
      p.withCountActiveProduct = true;
      p.withDistributors = true;
      p.withToken = true;
      p.withEndpoints = true;
      p.withAccountNumber = true;
      p.onlyUserDistributor = true;
      p.withLocalizationCountry = true;
      return p;
    }
  },
  computed: {
    canCreateSupplier() {
      return this.$store.getters.loggedInUser.roles?.find(
        (e) =>
          e.settings &&
          Object.keys(e.settings).find((k) =>
            (!Array.isArray(e.settings[k]) ? [] : e.settings[k]).find((e) =>
              [...ROLES_ACCESS.ACCOUNT_USERS, 'suppliers'].includes(e)
            )
          )
      );
    }
  },
  mounted() {
    this.checkPageWalkthroughs();
  }
};
</script>
